import { render, staticRenderFns } from "./RiskAssessmentRegular.vue?vue&type=template&id=009b1822&scoped=true"
import script from "./RiskAssessmentRegular.vue?vue&type=script&lang=js"
export * from "./RiskAssessmentRegular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009b1822",
  null
  
)

export default component.exports